import React, { FC, useState } from 'react'
//* utils
import { BlogTwitter } from '../../../../../constants/svg'

//* styles
import {
  BioCardContent,
  BioCardFooter,
  BioCardHolder,
  BioCardImage,
  BioCardQuote,
  BioCardWrapper,
  SocialMediaItem,
} from './style'

//* utils
import { WrapperImage as WrapperImageModel } from '../../../../../models/others/image'
import { MicrocopySet } from '../../../../../models/others/microcopy'

//* components
import Typography from '../../../../global/typography'
import WrapperImage from '../../../../global/wrapperImage'
import LeadershipModal from '../leadershipModal'

type Props = {
  headshot: WrapperImageModel | null
  miniBio: any
  firstName: string
  lastName: string
  role: string
  twitterProfile: string
  linkedInProfile: string
  microcopy: MicrocopySet | null
}

const LeadershipBio: FC<Props> = ({
  headshot,
  miniBio,
  firstName,
  lastName,
  role,
  twitterProfile,
  linkedInProfile,
  microcopy,
}) => {
  const fullName = `${firstName} ${lastName}`
  const image = {
    url: headshot?.image?.file?.url || '',
    alt: headshot?.image.altText || 'headshot',
  }

  const [modalOpen, setModalOpen] = useState(false)
  const [modalData, setModalData] = useState({})

  const openModal = () => {
    if (!miniBio) return null

    setModalData({
      fullName,
      role,
      miniBio,
      twitterProfile,
      linkedInProfile,
      image: image?.url || null,
      microcopy,
    })

    setModalOpen(true)
  }

  const closeModal = () => setModalOpen(false)

  return (
    <BioCardHolder $hasMiniBio={miniBio}>
      <BioCardWrapper className="BioCardWrapper" data-cy="BioCardWrapper" onClick={openModal}>
        {image.url && (
          <BioCardImage data-cy="BioCardImage">
            <WrapperImage src={image.url} alt={image.alt} />
            {miniBio && <BioCardQuote className="BioCardQuote-Block" />}
          </BioCardImage>
        )}

        {fullName && (
          <BioCardContent className="BioCardContent-FullName">
            <Typography className="BioCardContent-FullName-Label" type="header6">
              {fullName}
            </Typography>
          </BioCardContent>
        )}

        {role && (
          <BioCardContent className="BioCardContent-Role">
            <Typography type="bodyXS" className="font__inter">
              {role}
            </Typography>
          </BioCardContent>
        )}
      </BioCardWrapper>

      {(twitterProfile || linkedInProfile) && (
        <BioCardFooter>
          {twitterProfile && (
            <a href={twitterProfile} target="_blank">
              <SocialMediaItem className="BioPost__SocialMedia-Item">
                <BlogTwitter />
              </SocialMediaItem>
            </a>
          )}

          {linkedInProfile && (
            <a href={linkedInProfile} target="_blank">
              <SocialMediaItem className="BioCardFooter-LinkedInProfile" />
            </a>
          )}
        </BioCardFooter>
      )}

      <LeadershipModal onClose={closeModal} open={modalOpen} data={modalData} />
    </BioCardHolder>
  )
}

export default LeadershipBio
